/**
* @description: 新闻类别管理
* @version: V1.0
* @date: 2023-10-07
* @author: guoguo
*/
<template>
  <div>
    <div>
      <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch">
        <el-form-item label="类别名称" prop="name">
          <el-input
              v-model="queryParams.name"
              placeholder="请输入类别名称"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
  
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button
              type="primary"
              plain
              icon="el-icon-plus"
              size="mini"
              @click="handleAdd"
          >新增</el-button>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-table
        border
        :data="tableData"
        v-if="refreshTable"
        v-loading="loading"
        row-key="id"
        style="width: 36%;">
        <el-table-column
          type="index"
          width="100">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="200">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="类型名称"
          width="120">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-button @click="updateType(scope.row)" type="text" size="small">修改</el-button>
            <el-button @click="deleteType(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="类型名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入类型名称" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAll, updateType, deleteType, deleteBatchTypes, addType } from '@/api/type.js'
import { parseTime } from '@/utils/utils.js'
import { add } from '../../api/api';

export default {
  name: '',
  data () {
    return {
      refreshTable: true,
      showSearch: true,
      loading: true,
      tableData: [],
      queryParams: {
        name: ''
      },
      form: {
        id: undefined,
        name: ''
      },
      open: false, // 是否显示弹出框
      title: '', // 弹出框标题
      rules: {
        name: [
          {required: true, message: '类型名不能为空', trigger: 'blur'}
        ]
      },
    };
  },
  created() {}, // 生命周期 - 创建完成
  mounted() {
    this.handleQuery();
  }, // 生命周期 - 挂载完成
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  components: {},
  watch: {}, // 监控data中的数据变化
  computed: {}, // 计算属性，会监听依赖属性值随之变化
  methods: {
    reset() {
      this.form = {
        id: undefined,
        name: '',
      };
      this.queryParams = {
        name: undefined
      }
    },
    updateType(row) {
      this.form = row;
      this.open = true;
      this.title = "修改类型";
    },
    deleteType(row) {
      this.$confirm('是否删除选中的所有类型？删除后无法恢复!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteType({id: row.id}).then(res => {
            if(res.code === 200){
              this.getList();
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              });
            }
          }
        );
      }).catch(() => {});
    },
    getList() {
      getAll().then(res => {
        if (res.code == 200) {
          this.tableData = res.data;
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    handleAdd() {
      this.open = true;
      this.title = "添加类型";
    },
    parseTime(time, pattern) {
      return parseTime(time, pattern)
    },
    handleQuery() {
      this.tableData = undefined
      this.loading = true;
      getAll({name: this.queryParams.name}).then(res => {
        if (res.code == 200) {
          this.tableData = res.data;
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
        this.loading = false;
      })
    },
    resetQuery() {
      this.queryParams = {
        name: undefined
      }
      this.getList();
    },
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.form.id != undefined) {
            // 更新
            updateType(this.form).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '修改成功!'
                });
                this.open = false;
                this.getList();
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          } else {
            // 新增
            addType(this.form).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '添加成功'
                });
                this.open = false;
                this.getList();
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          }
        }
      })
    },
    cancel() {
      this.open = false;
      this.reset();
    }
  }, // 方法集合
}

</script>
<style lang='scss' scoped>
</style>